import React from 'react';

function getIntentClasses(intent) {
  if (!intent) return '';
  const lower = intent.toLowerCase();
  if (lower.includes('interested in') || lower.includes('wants site') || lower.includes('wants more'))
    return 'bg-emerald-100 text-emerald-700 border-emerald-200';
  if (lower.includes('not interested') || lower.includes('already bought') || lower.includes('wrong number'))
    return 'bg-rose-100 text-rose-700 border-rose-200';
  if (lower.includes('site visit'))
    return 'bg-blue-100 text-blue-700 border-blue-200';
  if (lower.includes('negotiation') || lower.includes('callback') || lower.includes('undecided'))
    return 'bg-amber-100 text-amber-700 border-amber-200';
  return 'bg-gray-100 text-gray-600 border-gray-200';
}

function getNextActionClasses(action) {
  if (!action) return '';
  const lower = action.toLowerCase();
  if (lower.includes('site visit') || lower.includes('schedule'))
    return 'bg-blue-100 text-blue-700 border-blue-200';
  if (lower.includes('callback') || lower.includes('call'))
    return 'bg-amber-100 text-amber-700 border-amber-200';
  if (lower.includes('whatsapp') || lower.includes('send') || lower.includes('brochure'))
    return 'bg-green-100 text-green-700 border-green-200';
  if (lower.includes('email'))
    return 'bg-purple-100 text-purple-700 border-purple-200';
  if (lower.includes('no action') || lower.includes('not interested'))
    return 'bg-rose-100 text-rose-700 border-rose-200';
  if (lower.includes('manager') || lower.includes('connect'))
    return 'bg-indigo-100 text-indigo-700 border-indigo-200';
  return 'bg-gray-100 text-gray-600 border-gray-200';
}

export function IntentBadge({ intent }) {
  if (!intent) return <span className="text-gray-400 text-xs">-</span>;
  const classes = getIntentClasses(intent);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${classes}`}>
      {intent}
    </span>
  );
}

export function NextActionBadge({ action }) {
  if (!action) return <span className="text-gray-400 text-xs">-</span>;
  const classes = getNextActionClasses(action);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${classes}`}>
      {action}
    </span>
  );
}
